import Radio from 'lib/components/radio/radio'
import Badge from 'lib/components/badge/badge'
import { ExternalLink } from 'lucide-react'
import { useBillingPlans } from './billing-plans-context'
import { displayPriceDifference, platformBasePlan, platformProPlan } from 'lib/util/billing'

export default function BillingModalPlatform() {
  const { currency, currentSubscriptions, period, plans, selectedPlans, updateSelectedPlans } = useBillingPlans()
  const priceDifference = (price: number) => price - (+selectedPlans?.platformPlan?.price || 0)
  const isSelectedPlatform = (platformPlanId: number) => selectedPlans?.platformPlan?.id === platformPlanId
  const isCurrentPlatform = (platformPlanId: number) =>
    currentSubscriptions?.platformSubscription?.picklePlan?.id === platformPlanId

  return (
    <div className="tw-mt-4 tw-flex tw-flex-col tw-gap-4">
      <div className="tw-flex tw-h-[4.5rem] tw-flex-row tw-items-center tw-gap-2 tw-rounded tw-border tw-border-solid tw-border-neutral-200 tw-p-4 has-[:checked]:tw-border-cornflower-300 has-[:checked]:tw-bg-neutral-50">
        <Radio
          id="base_platform"
          checked={isSelectedPlatform(platformBasePlan(plans)?.id)}
          name="platform"
          value={platformBasePlan(plans)?.id}
          type="radio"
          onChange={() => {
            updateSelectedPlans(platformBasePlan(plans), 'platform')
          }}
          className="tw-cursor-pointer"
        />
        <label
          htmlFor="base_platform"
          className="tw-mb-0 tw-flex tw-w-full tw-cursor-pointer tw-justify-between tw-text-peppercorn-900"
        >
          <div className="tw-flex tw-items-center">
            <div className="tw-text-peppercorn-900">Base Platform</div>
            {isCurrentPlatform(platformBasePlan(plans)?.id) && (
              <Badge color="neutral" className="tw-ml-2">
                Current
              </Badge>
            )}
          </div>
          {!isSelectedPlatform(platformBasePlan(plans)?.id) && (
            <div className="tw-w-32 tw-text-right">
              <div className="tw-font-semibold tw-text-peppercorn-900">
                {displayPriceDifference(priceDifference(+platformBasePlan(plans)?.price), currency)}
              </div>
              <div className="tw-font-normal">billed {period}</div>
            </div>
          )}
        </label>
      </div>
      <div className="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-rounded tw-border tw-border-solid tw-border-neutral-200 tw-p-4 has-[:checked]:tw-border-cornflower-300 has-[:checked]:tw-bg-neutral-50">
        <Radio
          id="pro_platform"
          checked={isSelectedPlatform(platformProPlan(plans)?.id)}
          name="platform"
          value={platformProPlan(plans)?.id}
          type="radio"
          onChange={() => {
            updateSelectedPlans(platformProPlan(plans), 'platform')
          }}
          className="tw-cursor-pointer"
        />
        <label
          htmlFor="pro_platform"
          className="tw-mb-0 tw-flex tw-w-full tw-cursor-pointer tw-justify-between tw-text-peppercorn-900"
        >
          <div>
            <div className="tw-flex tw-items-center">
              <div className="tw-text-peppercorn-900">Pro Platform</div>
              {isCurrentPlatform(platformProPlan(plans)?.id) && (
                <Badge color="neutral" className="tw-ml-2">
                  Current
                </Badge>
              )}
            </div>
            <div className="tw-font-normal">
              Advanced functionality and integrations
              <a
                href="https://help.designpickle.com/en/articles/3809732-which-plan-should-i-subscribe-to"
                target="_blank"
                rel="noreferrer"
                className="tw-text-squash-600 tw-ml-2 tw-cursor-pointer tw-text-cornflower-500 hover:tw-underline"
              >
                Learn more
                <ExternalLink className="tw-ml-1 tw-h-4 tw-w-4 tw-align-sub" />
              </a>
            </div>
          </div>
          {!isSelectedPlatform(platformProPlan(plans)?.id) && (
            <div className="tw-w-24 tw-text-right">
              <div className="tw-font-semibold tw-text-peppercorn-900">
                {displayPriceDifference(priceDifference(+platformProPlan(plans)?.price), currency)}
              </div>
              <div className="tw-font-normal">billed {period}</div>
            </div>
          )}
        </label>
      </div>
    </div>
  )
}
